import React, { useMemo, useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Layout, Checkbox, Row, Col, Form, Input, Select, Tooltip, Button, Popconfirm,Breadcrumb } from "antd";
import { ReactComponent as ArchiveRestore } from "../../image/ArchiveRestore.svg";
import { useTranslation } from "react-i18next";
import {
  InfoCircleOutlined, EditOutlined, DeleteOutlined, PlusCircleOutlined
} from "@ant-design/icons";
import "antd/dist/antd.min.css";
import "../../styles/Main.scss";
// import StepSider from "./StepSider";
import { authUserData } from "../../utils/Helper";
import { getRequest, postRequest } from "../../axios";
import { ErrorNotificationMsg, SuccessNotificationMsg } from "../../utils/Notifications";
import { ReactComponent as Archiveicon } from "../../image/Archiveicon.svg";
const onChange = (e) => {
  console.log(`checked = ${e.target.checked}`);
};
const { Content } = Layout;
const handleChange = (value) => {
  console.log(`selected ${value}`);
};
const ArchiveDeliveryList = () => {
  const navigate = useNavigate();
  const [arrow, setArrow] = useState('Show');
  const mergedArrow = useMemo(() => {
    if (arrow === 'Hide') {
      return false;
    }
    if (arrow === 'Show') {
      return true;
    }
    return {
      pointAtCenter: true,
    };
  }, [arrow]);
  const colors = ["#094E8F"];
  const { t } = useTranslation();
  const CompanyId = authUserData()?.company ? authUserData()?.company : null;
  const [loading, setLoading] = useState(false);
  const [reload, setReload] = useState(false);
  const [totalCount, settotalCount] = useState(0)
  const [SitelOcationlist, setSiteLocationList] = useState([]);

  const [state, setState] = useState({
    page: 1,
    ordering: "id",
    pagesize: 10
  });
  useEffect(() => {
    const getArchiveDeliveryList = async () => {
      setLoading(true);

      try {
        // let apiResponse = await getRequest(`delivery-address-restore/?company_id=${CompanyId}`, state);
        let apiResponse = await getRequest(
          `delivery-address-restore/${CompanyId}/get-restore-address-by-company/`,
          state
        );

        if (apiResponse.status) {
          // setArchiveDeliveryList(apiResponse.data.results);
          const sortedData = apiResponse.data.results.data.sort((a, b) => {
            return a.id - b.id;
          });

          setSiteLocationList(sortedData);
          settotalCount(apiResponse.data.count);
        } else {
          ErrorNotificationMsg(t("error_in_archive_list"));
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };
    getArchiveDeliveryList();
  }, [state, reload, t]);


  const handleRestore = async (id) => {
    try {
      let apiResponse = await postRequest("delivery-address-restore/", {
        deleted: [id], // Send the ID in an array as expected by your API
      });
      if (apiResponse.data.success) {
        SuccessNotificationMsg(t("delivery_address_restore_successfully"));
        setReload(!reload); // Trigger reload of employee list
        navigate("/delivery-address"); // Navigate to the employee list page after restore
      } else {
        ErrorNotificationMsg(t("error_in_restore_delivery_address"));
      }
    } catch (error) {
      ErrorNotificationMsg(error);
    }
  };

  return (
    <>

       <div className="ListingTopBar">
                 <div className="pagenamewrap">
                   <div className="pagename">
                   
                     <h3>Archive Site Location</h3>
         
                     <Breadcrumb className="Breadcrumb-Sec">
                       <Breadcrumb.Item>
                         <Link to="/dashboard">Dashboard</Link>
                       </Breadcrumb.Item>
         
                       <Breadcrumb.Item>Archive Site Location</Breadcrumb.Item>
                     </Breadcrumb>
                     </div>
                  
                   
                 </div>
               </div>
          <Content className="stepscontentwrap">
            <div className="stepsContent">
         
              <div className="cardswraper">
                <Row gutter={24}>
                  {/* <Col
                    xs={24}
                    sm={24}
                    md={12}
                    xl={8}
                    xxl={6}
                  >
                    <div className="stepcard addsite">
                      <div>
                        <Link to="/delivery-address/add">
                          <PlusCircleOutlined />
                        </Link>
                        <h5>Add Site Location</h5>
                      </div>
                    </div>
                  </Col> */}
                  {SitelOcationlist.map((item, index) => (
                    <Col
                      xs={24}
                      sm={24}
                      md={12}
                      xl={8}
                      xxl={6}
                      key={index}
                    >
                      <div className="stepcard sitecard">
                        <div className="cardtitle">
                          {item.company_name}
                          {/* <div className="action">                   
                        <Link to="/site-location-step/edit/:id"> <EditOutlined /> </Link> <DeleteOutlined /> */}
                          <div key={item.id} className="action">
                            {/* <Link to={`/delivery-address/edit/${item.id}`}><EditOutlined /> </Link> */}
                            <Popconfirm
                              className="action"
                              title={t("are_you_sure_to_restore")}
                              okText={t("pop_ok")}
                              cancelText={t("pop_cancel")}
                              onConfirm={() => handleRestore(item.id)}
                            >
                              {/* <DeleteOutlined  /> */}
                              <ArchiveRestore/>
                                </Popconfirm>
                          </div>
                        </div>
                        <Row gutter={16}>
                          <Col
                            xs={24}
                          >
                            <Form.Item

                            ><label>Legal Name of Business </label>
                              <span className="value">{item.company_legal_name}</span>
                            </Form.Item>
                          </Col>
                          <Col
                            xs={24}
                          >
                            <Form.Item

                            ><label>GSTN </label>
                              <span className="value">{item.gst_number}</span>
                            </Form.Item>
                          </Col>
                          <Col
                            xs={24}
                          >
                            <Form.Item

                            ><label>Address </label>
                              <span className="value">{item.shipping_address_line_1}</span>
                            </Form.Item>
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  ))}
                </Row>
              </div>

            </div>
            <div className="stepsFooter">
              {/* <Button
                cursor="pointer"
                type="secondary"
                className="primary"
                onClick={() => navigate("/material-master-step")}
              >
                Previous
              </Button> */}
              {/* <Button
                cursor="pointer"
                type="primary"
                className="primary"
               // onClick={() => navigate("/user-manage-group-step")}
              >
                Save 
              </Button> */}
            </div>
          </Content>
      
    </>
  );
};

export default ArchiveDeliveryList;
